import { useState } from 'react';
import { PIPELINE_API_GATEWAY_URI } from '../../../../../common/consts/api';
import Cookies from 'js-cookie';
import axios from 'axios';
import { trackEvents } from '../../../../../services/analytics';
import { COOKIES_KEYS, LOCAL_STORAGE_KEYS } from '../../../../../common/consts';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../../common/routes';
import BrowserStorageAccessor from '../../../../../common/BrowserStorageAccessor';
import useRulesFileValidator from './useRulesFileValidator';
import { KEYS_TO_REMOVE_FROM_REPO } from '../conts';

const getPlaygroundUserId = () => {
  const gsPlaygroundUserId =
    Cookies.get(COOKIES_KEYS.PLAYGROUND_USER_ID) ?? 'N/A';
  return gsPlaygroundUserId;
};

const executeGitstreamFn = async data => {
  try {
    const response = await axios.post(
      PIPELINE_API_GATEWAY_URI + '/playground',
      data
    );
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response?.data;
    }
    return {
      errors: error.message
    };
  }
};

const usePlaygroundData = () => {
  const navigate = useNavigate();
  const [gitstreamResults, setGitstreamResults] = useState('');
  const [gitstreamContext, setGitstreamContext] = useState(null);
  const [gitstreamErrors, setGitstreamErrors] = useState('');
  const [gitstreamAutomations, setGitstreamAutomations] = useState(null);
  const [loading, setLoading] = useState(false);
  const ruleFileValidator = useRulesFileValidator();

  const resetContext = () => {
    setGitstreamContext(null);
  };

  const executeGitstream = async prUrl => {
    setLoading(true);
    setGitstreamResults('');
    setGitstreamErrors('');

    const payload = {
      ruleFile: ruleFileValidator.ruleFile,
      prUrl,
      context: prUrl === gitstreamContext?.pr?.url ? gitstreamContext : null
    };

    const data = await executeGitstreamFn(payload);
    const isError = !!data?.errors;
    const passedAutomations = Object.values(data?.raw || {}).filter(
      ({ passed }) => passed
    );
    const newRepo = Object.keys(data?.context?.repo || {}).reduce(
      (newObj, key) => {
        if (!KEYS_TO_REMOVE_FROM_REPO.includes(key)) {
          newObj[key] = data?.context?.repo[key];
        }
        return newObj;
      },
      {}
    );

    const contextResult = {
      ...data?.context,
      ...(Object.keys(newRepo).length && { repo: newRepo })
    };

    setGitstreamResults(
      data?.results ||
        (data?.errors ? '' : 'Run successful, no actions applicable')
    );
    setGitstreamContext(contextResult);
    setGitstreamErrors(data?.errors || '');
    setGitstreamAutomations(data?.raw?.automations);
    trackEvents.playgroundRun({
      org: getPlaygroundUserId(),
      cm: ruleFileValidator.ruleFile,
      prUrl: data?.prUrl, //TODO: add this to response
      result: isError ? 'failed' : 'success',
      output: passedAutomations
    });
    setLoading(false);
  };

  const login = () => {
    BrowserStorageAccessor().local.set(
      LOCAL_STORAGE_KEYS.LAST_LOCATION,
      routes.playground.path
    );
    navigate(routes.login.path);
  };

  return {
    gitstreamContext,
    gitstreamResults,
    gitstreamErrors,
    gitstreamAutomations,
    loading,
    ruleFileValidator,
    executeGitstream,
    resetContext,
    login
  };
};

export default usePlaygroundData;
